var chunkMapping = {
	"35": [
		35
	],
	"129": [
		9129
	],
	"184": [
		9184
	],
	"189": [
		6189
	],
	"205": [
		9205
	],
	"216": [
		2216
	],
	"249": [
		4249
	],
	"302": [
		4302
	],
	"310": [
		2096,
		4157
	],
	"346": [
		4346
	],
	"352": [
		7352
	],
	"383": [
		8920,
		4729
	],
	"408": [
		7408
	],
	"442": [
		2478,
		4438
	],
	"461": [
		5128,
		1962
	],
	"463": [
		1463
	],
	"489": [
		6834,
		435
	],
	"512": [
		2277,
		3840
	],
	"523": [
		523
	],
	"524": [
		1524
	],
	"562": [
		3562
	],
	"674": [
		9750
	],
	"690": [
		9690
	],
	"714": [
		4143,
		8463
	],
	"730": [
		6730
	],
	"774": [
		4260,
		6193,
		7041
	],
	"797": [
		549,
		2291
	],
	"805": [
		1805
	],
	"838": [
		3059,
		8650
	],
	"906": [
		5906
	],
	"919": [
		919
	],
	"931": [
		931
	],
	"933": [
		4933
	],
	"970": [
		1970
	]
};
var idToExternalAndNameMapping = {
	"35": [
		"default",
		"./Swap",
		9018
	],
	"435": [
		"default",
		"./Partner",
		2111
	],
	"523": [
		"default",
		"./ProductCellAdd",
		9018
	],
	"549": [
		"default",
		"./GlobalStore",
		7664
	],
	"919": [
		"default",
		"./InputAmount",
		9018
	],
	"931": [
		"default",
		"./utils",
		9018
	],
	"1463": [
		"default",
		"./SwipeableList",
		9018
	],
	"1524": [
		"default",
		"./SwipeableListItem",
		9018
	],
	"1805": [
		"default",
		"./StatusScreen",
		9018
	],
	"1962": [
		"default",
		"./EditTemplate",
		3534
	],
	"1970": [
		"default",
		"./SwipeableListItem/useAnimateSwipeItem",
		9018
	],
	"2096": [
		"default",
		"./withPartner",
		2111
	],
	"2216": [
		"default",
		"./hooks",
		9018
	],
	"2277": [
		"default",
		"./UpdateTemplate",
		3534
	],
	"2291": [
		"default",
		"./LocalizationDictionary",
		1602
	],
	"2478": [
		"default",
		"./DisablePageOverlay",
		9018
	],
	"3059": [
		"default",
		"./AnimateHeightComponent",
		9018
	],
	"3562": [
		"default",
		"./Switch",
		9018
	],
	"3840": [
		"default",
		"./ActionSheet",
		9018
	],
	"4143": [
		"default",
		"./cardPay_v1",
		199
	],
	"4157": [
		"default",
		"./ServiceHandler",
		4149
	],
	"4249": [
		"default",
		"./Loader",
		9018
	],
	"4260": [
		"default",
		"./IntegrationHub",
		7910
	],
	"4302": [
		"default",
		"./ErrorInformer",
		9018
	],
	"4346": [
		"default",
		"./ProductCellSkeleton",
		9018
	],
	"4438": [
		"default",
		"./ErrorBox",
		9018
	],
	"4729": [
		"default",
		"./Content",
		9018
	],
	"4933": [
		"default",
		"./NavBar",
		9018
	],
	"5128": [
		"default",
		"./CreateTemplate",
		3534
	],
	"5906": [
		"default",
		"./InputTextarea",
		9018
	],
	"6189": [
		"default",
		"./Icon",
		9018
	],
	"6193": [
		"default",
		"./OTPComponent",
		9018
	],
	"6730": [
		"default",
		"./RightSheetComponent",
		9018
	],
	"6834": [
		"default",
		"./TransfersP2PSuspenseLoader",
		9531
	],
	"7041": [
		"default",
		"./limit_v0",
		199
	],
	"7352": [
		"default",
		"./InputCard",
		9018
	],
	"7408": [
		"default",
		"./InputOrdinaryComponent",
		9018
	],
	"8463": [
		"default",
		"./card_v3_02",
		199
	],
	"8650": [
		"default",
		"./BottomSheet",
		9018
	],
	"8920": [
		"default",
		"./Button",
		9018
	],
	"9129": [
		"default",
		"./SumCommissionView",
		9018
	],
	"9184": [
		"default",
		"./validations",
		9018
	],
	"9205": [
		"default",
		"./ProductCell",
		9018
	],
	"9690": [
		"default",
		"./NotificationToast",
		9018
	],
	"9750": [
		"default",
		"./hoc",
		9018
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}